// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".8dfcbbc354b544bc6c0ff8b16d8b667f.js";
};